import Vue from "vue";

Vue.component("annex-thresholds", {
    props: ["annexId", "partyId", "partyName","hasReciprocity","homePartyId"],
    data() {
        return {
            id: 0,
            loading: false,
            thresholds: [],
            hasEntity: false,
            nationalCurrency: null,
            isReciprocity: this.hasReciprocity,
            reciprocityClass: 'table-column-is-reciprocity',
            noReciprocityClass: ''
        };
    },
    methods: {
        getByAnnexId() {
            const self = this;

            self.loading = true;

            self.$services.nationalCurrencyThresholdsService.getByAnnexId({
                annexId: self.annexId,
                language: window.currentLanguage,
                homePartyId: self.homePartyId
            }).then((data) => {
                console.log(data);
                self.loading = false;
                self.thresholds = data.items;
                //self.hasEntity = data.hasEntity;
                self.nationalCurrency = data.nationalCurrency;
                if(self.homePartyId != null && self.homePartyId != "" && self.homePartyId != " "){
                    self.isReciprocity = data.hasReciprocity;

                    if (self.isReciprocity) {
                        this.$emit("update:hasReciprocity", self.isReciprocity);
                    }
                }
            });
        }
    },
    mounted() {
        this.getByAnnexId();
    },
    computed: {
        thresholdsForLabel: function () {
            return window.labels.thresholdsFor;
        },
        nationalCurrencyUrl: function () {
            return window.urls.nationalCurrency + "?PartyId=" + this.partyId + "&PartyName=" + this.partyName;
        }
    },    
    template: `
		<div class="annex-thresholds">
			<template v-if="loading"><loading></loading></template>
			<template v-else>
                <div class="table-container">
                    <table class="table is-bordered is-striped is-hoverable">
                        <thead>
                            <tr>
                                <th style="width: 200px">{{thresholdsForLabel}}</th>
                                <th style="width: 100px" align="right">SDR</th>
                                <th style="width: 100px" align="right" v-if="nationalCurrency">{{nationalCurrency}}</th>
                            </tr>
                        </thead>
                        <tbody v-for="threshold in thresholds" :key="threshold.id" :id="threshold.id">
                            <tr>
                                <td :class="[threshold.isReciprocity ? 'table-column-is-reciprocity': '']">
                                    <span v-html="threshold.displayName"></span>
                                </td>
                                <td align="right" :class="[threshold.isReciprocity ? 'table-column-is-reciprocity': '']">
                                    {{threshold.sdrValue}}
                                </td>
                                <td v-if="nationalCurrency" align="right" :class="[threshold.isReciprocity ? 'table-column-is-reciprocity': '']">
                                    {{threshold.currencyValue}}
                                </td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td align="center" :colspan="nationalCurrency ? 3 : 2">
                                    <a :href="nationalCurrencyUrl">National Currencies</a>
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
			</template>			
		</div>
	`
});